import * as React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {withFormsy} from 'formsy-react';
import style from './Input.css';

const inputTypes = {
    text: "text",
    radio: "radio",
    textArea: "textarea",
    radioGroup: "radio-group"
};

export class Input extends React.Component {
    constructor(props) {
        super(props);
        this.changeValue = this.changeValue.bind(this);
    }

    changeValue(event) {
        console.log('changeValue: ', this.props.name, event.currentTarget.value);
        this.props.setValue(event.currentTarget.value);
    }

    renderInputByType(type) {
        switch (type) {
            case inputTypes.radioGroup:
                return (
                    <div className={style.radioGroup}>
                        {React.Children.map(this.props.children, (child) => {
                            return React.cloneElement(child, {
                                name: this.props.name,
                                onChange: this.changeValue
                            });
                        })}
                    </div>
                );
            case inputTypes.radio:
                return (
                    <label className={style.radio}>
                        {this.props.label}
                        <input
                            type="radio"
                            name={this.props.name}
                            onChange={this.props.onChange}
                            value={this.props.value}
                        />
                        <span className={style.checkmark}/>
                    </label>

                );
            case inputTypes.textArea:
                return <textarea
                    className={cx(style.input, style.textarea)}
                    name={this.props.name}
                    placeholder={this.props.placeholder}
                    onChange={this.changeValue}
                    value={this.props.getValue() || ''}
                />;
            case inputTypes.text:
            default:
                return <input
                    className={style.input}
                    name={this.props.name}
                    autoComplete={this.props.autoComplete}
                    type="text"
                    placeholder={this.props.placeholder}
                    onChange={this.changeValue}
                    value={this.props.getValue() || ''}
                />;
        }
    }

    render() {
        const {className, type, name, label} = this.props;
        let errorMessage = '';

        if (this.props.isPristine) {
            const isPristine = this.props.isPristine();
            const hasValue = !!this.props.getValue();
            const showError = this.props.showError();

            const hasError = (!isPristine && (showError || !hasValue));
            errorMessage = hasError && this.props.getErrorMessage();
        }

        return (
            <div className={cx(style.root, className)}>
                {label && type !== inputTypes.radio && <label className={style.label} htmlFor={name}>
                    {label}
                </label>
                }
                {this.renderInputByType(type)}
                {errorMessage && <span className={style.errorMessage}>{errorMessage}</span>}
            </div>
        );
    }
}

Input.propTypes = {
    type: PropTypes.string,
    placeholder: PropTypes.string
};

Input.defaultProps = {
    className: '',
    type: 'text',
    value: '',
    autoComplete: "nope"
};

export const FormsyInput = withFormsy(Input);